var swNotifications = require('js/lib/notifications/sw-notifications');
var $ = require('js/sw-jquery/sw-jquery');

$(document).ready(function() {
  $('body').on('submit', '[data-sw-sign-up-form]', function (e) {
    e.preventDefault();
    var formElement = $(this);
    var data = formElement.serialize();
    var errorElements = $(formElement).find('.error');
    $(errorElements).hide();
    var postUrl = $(formElement).attr("action");


    $(formElement).find('.btn-primary').addClass('waiting');

    $.ajax({
      url: postUrl,
      type: 'POST',
      xhrFields: {withCredentials: true},
      beforeSend: function (xhr) {
        xhr.withCredentials = true;
      },
      data: data,
      dataType: "json",
      success: function (response) {
        if (response.success === true) {
          var targetUrl = response.targetUrl || $(formElement).find("input[name='targetUrl']").val();

          if (targetUrl !== '') {
            if (targetUrl.indexOf('#') === 0) {
              window.location.reload();
            }

            if (targetUrl.indexOf('event:') === 0) {
              var doneEvent = targetUrl.replace('event:', '');
              window.sw.trigger(doneEvent, response);
            }

            window.location.href = '/forward?targetUrl=' + encodeURIComponent(targetUrl);

          } else {
            window.location.reload();
          }

        }
        else {
          $(formElement).find('.btn-primary').removeClass('waiting');

          var fieldErrors = response.errors.fieldErrors;

          if (fieldErrors.email) {
            formElement.find('.email-error').html(fieldErrors.email).show();
          }

          if (fieldErrors.username) {
            formElement.find('.username-error').html(fieldErrors.username).show();
          }

          if (fieldErrors.password) {
            formElement.find('.password-error').html(fieldErrors.password).show();
          }

          if (fieldErrors.firstName) {
            formElement.find('.firstName-error').html(fieldErrors.firstName).show();
          }

          if (fieldErrors.lastName) {
            formElement.find('.lastName-error').html(fieldErrors.lastName).show();
          }

          if (fieldErrors.phoneNumber) {
            formElement.find('.phoneNumber-error').html(fieldErrors.phoneNumber).show();
          }

          if (fieldErrors._csrf) {
            swNotifications.error(fieldErrors._csrf);
          }

          if (fieldErrors.recaptcha) {
            swNotifications.error(fieldErrors.recaptcha);
          }
        }
      }
    });
    return false;
  });
});
